import { render, staticRenderFns } from "./DeliveryCampaignGroupsPage.vue?vue&type=template&id=c41317b8&scoped=true"
import script from "./DeliveryCampaignGroupsPage.vue?vue&type=script&lang=js"
export * from "./DeliveryCampaignGroupsPage.vue?vue&type=script&lang=js"
import style0 from "./DeliveryCampaignGroupsPage.vue?vue&type=style&index=0&id=c41317b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41317b8",
  null
  
)

export default component.exports